module.exports = __webpack_public_path__ + "static/media/033.5f442024.jpg";